module.exports = __webpack_public_path__ + "static/media/signOnLogoWhite.53d7cf53.svg";